import axios from "./axios";

class AuthService {
  loginWithMobile = async (mobile) => {
    try {
      const response = await axios.post(
        "/login/login_without_pass",
        { mobile },
        {
          headers: {
            "X-App-Version": "1.0.0",
          },
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      // Safe fallback for nested error messages
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyOtp = async (otp, token) => {
    try {
      const response = await axios.post("/login/verify_otp", { otp, token });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}

export default new AuthService();
